<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2021-12-03 10:13:20
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-12-03 10:48:27
-->
<template>
  <div class="container">
    <head-nav-bar title="选择就诊人" :fixed="true" />
    <div class="mt-header-nav chooseContact">
      <span v-for="(item, index) in contactList" :key="index">
        <van-button
          @click="chooseContact(item)"
          style="margin: 0 10px"
          size="small"
          type="info"
          >{{ item.CardholderName }}</van-button
        >
      </span>
      <van-button
        @click="chooseContact()"
        type="primary"
        size="small"
        style="margin: 0 10px"
        >无就诊卡</van-button
      >
    </div>
    <van-overlay :show="chooseContactJump">
      <div class="wrapper" @click.stop>
        <van-loading />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Button, Overlay, Loading } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  data() {
    return {
      contactList: [],
      chooseContactJump: false,
      HospitalId: "",
      epidemicType: "1"
    };
  },
  created() {
    this.HospitalId = this.$route.query.hospitalId;
    if (this.$route.query.epidemicType) {
      this.epidemicType = this.$route.query.epidemicType;
    }
    this.getContact();
  },
  methods: {
    getContact() {
      this.$post("Contact_List").then(res => {
        this.contactList = res.Data.Datas;
      });
    },
    chooseContact(contactInfo) {
      const _this = this;
      // this.chooseContactJump = true;
      // setTimeout(() => {
      if (contactInfo) {
        _this.$router.push({
          name: "screeningFormForm",
          query: {
            HospitalId: this.HospitalId,
            contactId: contactInfo.Id,
            epidemicType: this.epidemicType
            // DiagnosisCardNo: contactInfo.DiagnosisCardNo,
            // PatientName: contactInfo.CardholderName,
            // PatientSex: contactInfo.CardholderSex,
            // PatientIdentityNo: contactInfo.IdentityDocNo,
            // PatientContactPhone: contactInfo.CardholderContactPhone
          }
        });
      } else {
        // 点击无就诊人逻辑
        _this.$router.push({
          name: "screeningFormForm",
          query: {
            HospitalId: this.HospitalId,
            epidemicType: this.epidemicType
          }
        });
      }
      this.chooseContactJump = false;
      // }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    padding: 0.5rem 1rem;
    border-radius: 5px;
    background-color: #fff;
    font-size: 0.4rem;
    font-weight: bold;
  }
}
</style>
